<template>
    <div>
        <!-- delete role -->
        <delete-dialog
            ref="deleteDialog"
            :success-message="$t('message.data-is-deleted')"
            @on-delete="updateItem(); $router.replace({name: 'Roles',  params: {}, query: {} })"
        >
			{{ $t('are-you-sure-you-want-to') }} {{$t('delete')}} {{$t('Role.this-role') + $t('?')}}
        </delete-dialog>
        <!-- roleDialog -->
        <v-dialog v-model="roleDialog" persistent width="400" @keydown.esc="roleDialog = false">
            <v-form ref="form" @submit.prevent="save">
                <v-card>
                    <div class="d-flex justify-end py-1 background-title-card ">
                        <v-card-title
                            class="text-uppercase text-subtitle-1 d-flex justify-center w-100 px-0 py-0 white--text"
                        >
                            {{$t('Role.add-new-role')}}
                        </v-card-title>
                        <!-- close button -->
                        <v-btn icon @click="roleDialog = false; $refs.form.resetValidation()">
                            <v-icon color="white">
                                mdi-close-circle-outline
                            </v-icon>
                        </v-btn>
                    </div>

                    <!-- text -->
                    <v-card-text class="pt-2 pb-0">
                        <v-row>
                            <v-col cols="6" align-self="center">
                                <v-text-field
                                    v-model="dialogData.name"
                                    :label="$t('inputs.name')"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    :disabled="submitLoading"
                                    :rules="rules.required"
                                    autofocus
                                />
                            </v-col>
                            <v-col cols="6" align-self="center">
                                <v-autocomplete
                                    v-model="dialogData.type"
                                    :items="userTypes"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('inputs.type')"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    :disabled="submitLoading"
                                    :rules="rules.required"
                                />
                            </v-col>
                            <v-col cols="12" align-self="center" class="pt-0">
                                <v-autocomplete
                                    v-model="dialogData.parentId"
                                    :items="roles"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    outlined
                                    :label="$t('inputs.direct-manager')"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            type="submit"
                            text
                            color="success"
                            :loading="submitLoading"
                        >
                            {{$t('save')}}
                        </v-btn>

                        <v-btn
                            @click="roleDialog = false"
                            text
                            :disabled="submitLoading"
                        >
                            {{$t('cancel')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        
        <v-row class="mt-3 mx-1">
            <v-col
                cols="12"
                sm="12"
                md="3"
                class="style-tree px-0 py-0"
            >
                <!-- add button -->
                <div v-if="!firstLevel" class="px-2 pt-0 pb-md-0 pb-1 mt-2">
                    <v-btn
                        v-if="isSuperAdmin || permissionsUser.Roles === roleName.action"
                        elevation="1"
                        color="primary"
                        class="px-2 mb-2"
                        :disabled="disableAddBtn"
						small
                        @click="roleDialog = true"
                    >
                        <v-icon class="me-1">mdi-seed-plus-outline</v-icon>
                        {{$t('add')}}
                    </v-btn>
                </div>
                <!-- tree -->
                <v-treeview
					:items="roleTree"
					:itemOpen.sync="itemOpen"
					:active.sync="activeNodes"
					:open.sync="openNodes"
					expand-icon=""
					active-class="deep-orange--text text--darken-1"
					@update:active="previewItem(activeNodes[0]); openNodes.push($event.id)"
					:disabled="disableAddBtn"
                    activatable
                    :calculate-width="true"
                    :open-all="true"
				>
					<template v-slot:prepend="{ item, open }">
						<v-icon
							v-if="item.children.length"
							class="mx-0"
							@click="
								open && !disableAddBtn
								? openNodes.splice(openNodes.indexOf(item.id), 1)
								: openNodes.push(item.id)"
						>   
							{{open ? 'mdi-minus' : 'mdi-plus'}}
						</v-icon>
					</template>
				</v-treeview>
            </v-col>
            <v-col cols="12" sm="12" md="9">
                <template v-if="$route.params.id">
                    <v-row>
                        <v-col align-self="center" cols="4">
                            <v-text-field
                                v-model="namingRole"
                                :label="$t('inputs.job-title')"
                                dense
                                outlined
                                hide-details
                                :disabled="Boolean($route.query.preview) || loading"
                                :loading="loading"
                                :readonly="firstLevel"
                            />
                        </v-col>
                        <v-col align-self="center" cols="4">
                            <v-autocomplete
                                :items="roles.filter(c => c.name !== namingRole)"
                                item-text="name"
                                item-value="id"
                                v-model="parentId"
                                :label="$t('inputs.manager')"
                                dense
                                outlined
                                hide-details
                                :disabled="Boolean($route.query.preview) || loading"
                                :loading="loading"
                            />
                        </v-col>

                        <v-col align-self="center" cols="4">
                            <v-autocomplete
                                v-model="type"
                                :items="userTypes"
                                item-text="name"
                                item-value="id"
                                :label="$t('inputs.type')"
                                dense
                                outlined
                                hide-details
                                :disabled="Boolean($route.query.preview) || loading"
                                :loading="loading"
                                :readonly="firstLevel"
                            />
                        </v-col>
                        
                        <v-spacer />
                        <v-col class="d-flex justify-end pb-0">
                            <v-btn
                                v-if="isSuperAdmin || permissionsUser.Roles === roleName.action"
                                @click="$route.query.preview ? $router.replace({ 
                                    name: 'Roles', 
                                    params: { id: $route.params.id },
                                    query: {} 
                                }) : update()"
                                small
                                :color="$route.query.preview ? 'edit-color white--text' : 'success' "
                                :disabled="!Boolean($route.params.id)"
                            >
                                <v-icon small class="me-2"> 
                                    {{ $route.query.preview ? 'mdi-pencil' : 'mdi-content-save' }}
                                </v-icon>
                                {{ $route.query.preview ? $t('edit') : $t('save') }}  
                            </v-btn>

                            <v-btn
                                v-if="(isSuperAdmin || permissionsUser.Roles === roleName.action) && !firstLevel"
                                :disabled="!Boolean($route.params.id)"
                                class="text-none mx-2"
                                color="alert-color white--text"
                                small
                                @click="$refs.deleteDialog.activeDeleteDialog($route.params.id, 'rolePermission', 'delete')"
                            >
                                <v-icon small class="me-2"> mdi-delete </v-icon>
                                {{$t('delete')}}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <div>
                        <h3 class="primary--text mb-2"> {{$t('Role.permissions')}} </h3>
                        <bee-handy-table
                            :headers="headers"
                            :items="myItems"
                            dense
                            zebra
                            :height="$vuetify.breakpoint.height - 160"
                            :items-per-page="-1"
                            fixed-header
                            hide-default-footer
                            :loading="loading"
                        >
                            <template v-slot:item.rolePermissions="{ item }">
                                <v-radio-group
                                    v-model="item.rolePermissions"
                                    row
                                    hide-details
                                    class="mt-0"
                                    :disabled="Boolean($route.query.preview)"
                                >
                                    <v-radio
                                        :label="$t('Role.read')"
                                        :value="1"
                                    ></v-radio>
                                    <v-radio
                                        :label="$t('Role.action')"
                                        :value="2"
                                    ></v-radio>
                                    <v-radio
                                        :label="$t('Role.nothing')"
                                        :value="0"
                                    ></v-radio>
                                </v-radio-group>
                            </template>
                        </bee-handy-table>
                    </div>
                </template>
                <div
                	v-else
                	class="d-flex flex-column justify-center align-center"
                	:style="{ height: `${$vuetify.breakpoint.height - 90}px` }"
                >
                    <v-progress-circular
                    	v-if="loading"
                        color="primary"
                    	indeterminate
                        size="44"
                        width="4"
                    />
                    <template v-else>
                        <v-icon size="60" class="mb-1">mdi-account-cog</v-icon>
                        <span class="text-h6">{{$t('Role.please-select-a-role')}}</span>
                    </template>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { permissions, permissionsWithName, roleName, userTypes } from '../../../helpers/enums'
import { firstLevel } from '@/configs/global.config'
import DeleteDialog from '@/components/DeleteDialog'
import { makeTree, transformData } from '@/helpers/functions'
import rules from '@/validation rules'
export default {
    components: {
        DeleteDialog
    },
    data () {
        return {
            makeTree,
            permissions,
            permissionsWithName,
  
            submitLoading: false,
            loading: false,
            roleName,
        
            namingRole: null,
            parentId: null,
            dialogData: {
                name: null,
                parentId: null,
                type: null
            },
            roleDialog: false,
            itemOpen: 10000,
			activeNodes: [],
			openNodes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            disableAddBtn: false,
            myItems: [
                {
                    permissionsNames: permissions.Leaves,
                    rolePermissions: null,
                    explain: 'قبول/رفض الاجازات المقدمة من الموظفين'
                },
                {
                    permissionsNames: permissions.AddLeavesForStaff,
                    rolePermissions: null,
                    explain: 'إضافة إجازة'
                },
                {
                    permissionsNames: permissions.ManageLeaveBalances,
                    rolePermissions: null,
                    explain: 'إدارة عدد أيام الإجازات السنوية'
                },
                {
                    permissionsNames: permissions.GenerateMaterials,
                    rolePermissions: null,
                    explain: 'إدارة و توليد المواد'
                },
                {
                    permissionsNames: permissions.MaterialTransactions,
                    rolePermissions: null,
                    explain: 'مناقلة المواد بين الموظفين.',
                },
                {
                    permissionsNames: permissions.MedicalPlans,
                    rolePermissions: null,
                    explain: 'إدارة واستعراض خطط المندوبين.',
                },
                {
                    permissionsNames: permissions.MedicalVisits,
                    rolePermissions: null,
                    explain: 'إدارة واستعراض زيارات المندوبين',
                },
                {
                    permissionsNames: permissions.WeeklyReports,
                    rolePermissions: null,
                    explain: 'إدارة واستعراض تقارير الزيارة المزدوجة- التقرير الإداري',
                },
                {
                    permissionsNames: permissions.MonthlyPlanReports,
                    rolePermissions: null,
                    explain: 'التقارير الشهرية',
                },
                {
                    permissionsNames: permissions.Reviews,
                    rolePermissions: null,
                    explain: 'إدارة واستعراض تقييمات.',
                },
                {
                    permissionsNames: permissions.Exams,
                    rolePermissions: null,
                    explain: 'إدارة واستعراض اختبارات. ',
                },
                {
                    permissionsNames: permissions.Salaries,
                    rolePermissions: null,
                    explain: 'إدارة واستعراض الرواتب. ',
                },
                {
                    permissionsNames: permissions.MedicalReps,
                    rolePermissions: null,
                    explain: 'إدارة واستعراض بيانات الموظفين.',
                },
                {
                    permissionsNames: permissions.Entities,
                    rolePermissions: null,
                    explain: ' إدارة واستعراض بيانات الزبائن.',
                },
                {
                    permissionsNames: permissions.EntityModificationRequests,
                    rolePermissions: null,
                    explain: 'الموافقة او الاطلاع على طلبات التعديل للزبائن المرسلة من قبل المندوبين.',
                },
                {
                    permissionsNames: permissions.Charts,
                    rolePermissions: null,
                    explain: 'الوصول للمخططات و إنشاؤها.',
                },
                {
                    permissionsNames: permissions.Regions,
                    rolePermissions: null,
                    explain: 'إدارة المدن والمناطق.',
                },
                {
                    permissionsNames: permissions.Users,
                    rolePermissions: null,
                    explain: 'تعديل بيانات الدخول للموظفين كـ الـUserName و الPassword يجب إضافة القيمة read للـRep للاطلاع على الملف الشخصي.',
                },
                {
                    permissionsNames: permissions.Roles,
                    rolePermissions: null,
                    explain: 'إدارة الأدوار الوظيفية وصلاحياتها.',
                },
                {
                    permissionsNames: permissions.GeneralFilter,
                    rolePermissions: null,
                    explain: 'الفلاتر العامة ضمن النظام كـ فلتر السنوات.',
                },
                {
                    permissionsNames: permissions.ManageTeam,
                    rolePermissions: null,
                    explain: 'التعديل بـ بيانات الفرق كـ إضافة وتعديل.',
                }
            ],
            tree: null,
            jobTitle: 'team lader',

            items: [
                {
                    id: 1,
                    name: 'regional manager',
                    children: [
                        { 
                            id: 2, 
                            name: 'supervisor',
                            children: [
                                {
                                    id: 4, 
                                    name: 'Team Leader',
                                    children:[
                                        {
                                            id: 5, 
                                            name: 'Medical rep'
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            radioGroup: 1,
            type: null,
            firstLevel,
            userTypes,
            rules
            // roleTree: []
        }
    },

    watch: {
        watchRoute(val) {
			const routeDataArray = val.split(' | ');
			const routData = { name: routeDataArray[0], id: routeDataArray[1], preview: routeDataArray[2] }
			if (routData.name === 'Roles' || !routData.id) {
				this.activeNodes = [];
			}
		},

        roleDialog(val) {
            if (!val) {
                this.dialogData.name = null;
                this.dialogData.parentId = null
                this.dialogData.type = null
                this.$refs.form.resetValidation()
            }
        }
    },

    computed: {
        ...mapState({
            roles: state => state.rolePermission.roles,
            permissionsUser: state => state.auth.youPermissions,
            isSuperAdmin: state => state.auth.isSuperAdmin,
            userLogin: state => state.auth.self.employeeId,
            roleTree: state => transformData(state.rolePermission.tree)
        }),

        headers() {
            return [
                {
                    text: this.$t('headers.name'),
                    name: 'Name',
                    value: 'permissionsNames',
                    noNotAvailableText: true,
                    setValueExpr: val => this.permissionsWithName.find(c => c.id === val)?.permissionName
                },
                {
                    text: this.$t('headers.permissions'),
                    name: 'rolePermissions',
                    value: 'rolePermissions'
                },
                {
                    text: this.$t('headers.explanation'),
                    name: 'explain',
                    value: 'explain',
                    width: '40%'
                }
            ]
        }
    },

    methods: {
        transformData,
		previewItem(id) {
            if (!id || id === this.$route.params.id) return;
            this.loading = true

            this.$store.dispatch('rolePermission/fetchById', { id: id }).then((data) => {
                this.namingRole = data.data.name
                this.parentId = data.data.parentRoleId
                this.type = data.data.type
                this.myItems = this.myItems.map(c => ({
                    explain: c.explain,
                    permissionsNames: c.permissionsNames,
                    rolePermissions: data.data.permissions.find(x => x.permissionsNames === c.permissionsNames)?.rolePermissions
                }))
                this.$router.replace({
                    params: {
                        id: data.data.id
                    },
                    query: {
                        preview: true
                    }
                })
            }).finally(() => {
                this.loading = false
            })
		},

        updateTree() {
			if (this.$route.name === 'Roles' && this.$route.params.id) {
				this.itemOpen = this.$route.params.id;
				this.activeNodes = [this.$route.params.id];
			}
		},

        fetchAll () {
            return this.permissionsUser.Roles !== roleName.nothing ? this.$store.dispatch('rolePermission/fetchChildrenRole', { id: this.userLogin }) : null
        },
        // add new role
        save () {
            if (!this.$refs.form.validate()) return
            this.submitLoading = true
            this.$store.dispatch('rolePermission/create', { 
                name: this.dialogData.name, 
                parentId: this.dialogData.parentId,
                type: this.dialogData.type
            }).then(() => {
                this.fetchAll().then((data) => {
                    // this.items.push({
                    //     ...data
                    // })
                    // this.roleTree = this.isSuperAdmin ? makeTree(this.roles) : this.roles
                    this.roleDialog = false
                    this.submitLoading = false
                })
            })
        },
        
        updateItem () {
            this.fetchAll().then(() => {
                // this.items.push({
                //     ...data
                // })
                // this.roleTree = this.isSuperAdmin ? makeTree(this.roles) : this.roles
                this.roleDialog = false
                this.submitLoading = false
            })
        },
        update () {
            this.loading = true
            this.$store.dispatch('rolePermission/update', { 
                id: this.$route.params.id,
                newName: this.namingRole,
                parentRoleId: this.parentId,
                permissions: this.myItems,
                type: this.type
            }).then((data) => {   
                this.fetchAll().then((data) => {
                    // this.roleTree = this.isSuperAdmin ? makeTree(this.roles) : this.roles
                    this.roleDialog = false
                    this.submitLoading = false
                })
                this.$router.replace({
                    query: {
                        preview: true
                    }
                })
            }).finally(() => {
                this.loading = false
            })
        }
    },

    created () {
        this.$store.dispatch('rolePermission/fetchTree').then(() => {
            if (this.$route.params.id) {
                this.activeNodes.push(
                    this.$route.params.id
                ) 
            } else {
               this.activeNodes = []
            }
        })
        this.$store.dispatch('rolePermission/fetchChildrenRole', { id: this.userLogin }).then(() => {
            // this.roleTree = this.isSuperAdmin ? makeTree(this.roles) : this.roles
            //     if (this.$route.params.id) {
            //         this.activeNodes.push(
            //             this.$route.params.id
            //         ) 
            //     } else {
            //         this.activeNodes = []
            //     }
        })
    }
}
</script>

<style>
.style-tree {
    background: #118aa825;
    border-radius: 10px;
}

.v-treeview-node__label {
    cursor: pointer;
}
</style>